module.exports = __webpack_public_path__ + "images/fa-free-offer-upgrade-bg.jpg";